import { put , call, takeEvery} from 'redux-saga/effects';
import {setApprovalList , setApiStatus, setSelectedTab} from '../actions/ApprovalListActions';
import ApprovalService from "../services/ApprovalService";
import LoggerService from "../services/LoggerService";
import store from "../stores/store";
import _ from 'lodash';
import { ACTIVITY, ACTIVITY_CATEGORY } from '../constants/LogConstants';


export function* approvalDetailsSaga(){

    yield takeEvery('GET_APPROVAL_DETAILS', function* (action){
        const { approvalId } = action;
        yield call(approvalDetailsActionSaga,approvalId);
    })  
}

export function* approvalDetailsActionSaga(approvalId){
    let list = [];
    yield put(setApprovalList(list));
    yield put(setApiStatus(true));
    const userInfo = _.get(store.getState(), "AuthReducer.userInfo", {});
    try{
        const response = yield call(ApprovalService.getApprovalDetails, approvalId);
        yield put(setApiStatus(false));
        if (response.data) {
            //set selected tab ID, workflowID
            yield put(setSelectedTab(response.data.flowId));

            let approvalList = [];
            approvalList.push(response.data);
            //set approval List
            yield put(setApprovalList(approvalList));
            const messageObject = {};
            messageObject.Message = "Fetched approval details successfully";
            messageObject.Functionality = ACTIVITY.FETCH_APPROVAL_DETAILS;
            messageObject.ActivityCategory = ACTIVITY_CATEGORY.FETCH;
            messageObject.Source_System = "Commerce";
            messageObject.Flow = "Get Approval Details";
            messageObject.Screen = "CustomerApprovalPortal";
            messageObject.AgentId = "";
            messageObject.CustomerGuid = _.has(userInfo, "userId") ? userInfo.userId : "";
            messageObject.countryCode = _.has(userInfo, "countryCode") ? userInfo.countryCode : "";
            messageObject.approvalId = approvalId;
            messageObject.Result = 'Success';
            LoggerService.saveSplunkLog(messageObject, 'info');
        }
    }catch(error){
        yield put(setApiStatus(false));
        yield put(setApprovalList([]));
        const messageObject = {};
        messageObject.Message = "Failed to fetch approval details";
        messageObject.Functionality = ACTIVITY.FETCH_APPROVAL_DETAILS;
        messageObject.ActivityCategory = ACTIVITY_CATEGORY.FETCH;
        messageObject.Source_System = "Commerce";
        messageObject.Flow = "Get Approval Details";
        messageObject.Screen = "CustomerApprovalPortal";
        messageObject.AgentId = "";
        messageObject.CustomerGuid = _.has(userInfo, "userId") ? userInfo.userId : "";
        messageObject.countryCode = _.has(userInfo, "countryCode") ? userInfo.countryCode : "";
        messageObject.approvalId = approvalId;
        messageObject.errorMessage = error && error.message ? error.message : '';
        messageObject.Result = 'Failure';
        LoggerService.saveSplunkLog(messageObject, 'error');
    }

}
